import React, { useState } from "react";
import { Box, Button, Grid, TextareaAutosize, Typography } from "@mui/material";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import AddNameBtn from "../FileuploadWithPreview/AddNameBtn";
import copy from "../../../src/assests/images/copy.svg";
import trash from "../../../src/assests/images/trash.svg";
import marker from "../../../src/assests/images/marker_black.svg";

interface NoteItem {
  id: number;
  value: string;
}

interface GridItem {
  id: number;
  notes: NoteItem[];
  title: string;
  placeholderPrefix?: string;
}

interface NotesProps {
  gridData: GridItem[];
  trashIcon: string;
  plusIcon: string;
  onGridChange?: (gridData: GridItem[]) => void;
}

const Notes: React.FC<NotesProps> = ({ gridData, trashIcon, plusIcon, onGridChange, }) => {

  const [data, setData] = useState<GridItem[]>(gridData);

  const handleNoteChange = (gridId: number, noteId: number, value: string) => {
    const updatedData = data.map((gridItem) =>
      gridItem.id === gridId
        ? {
          ...gridItem,
          notes: gridItem.notes.map((note) =>
            note.id === noteId ? { ...note, value } : note
          ),
        }
        : gridItem
    );
    setData(updatedData);
    if (onGridChange) onGridChange(updatedData);
  };

  const addNote = (gridId: number) => {
    const updatedData = data.map((gridItem) =>
      gridItem.id === gridId
        ? {
          ...gridItem,
          notes: [
            ...gridItem.notes,
            { id: Date.now(), value: "" }, // Unique ID
          ],
        }
        : gridItem
    );
    setData(updatedData);
    if (onGridChange) onGridChange(updatedData);
  };

  const removeNote = (gridId: number, noteId: number) => {
    const updatedData = data.map((gridItem) =>
      gridItem.id === gridId
        ? {
          ...gridItem,
          notes: gridItem.notes.filter((note) => note.id !== noteId),
        }
        : gridItem
    );
    setData(updatedData);
    if (onGridChange) onGridChange(updatedData);
  };

  const removeGrid = (gridId: number) => {
    const updatedData = data.filter((gridItem) => gridItem.id !== gridId);
    setData(updatedData);
    if (onGridChange) onGridChange(updatedData);
  };

  const handleCopyNote = (noteValue: string) => {
    navigator.clipboard
      .writeText(noteValue)
      .then(() => {
        alert('Note copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy note:', err);
      });
  };

  return (
    <Grid container spacing={2}>
      {data.map((gridItem) => (
        <React.Fragment key={gridItem.id}>
          <Grid item md={11}>
            <Box sx={{ display: "flex", flexDirection: "column", padding: "24px", backgroundColor: "#FFF", borderRadius: "16px", marginBottom: "24px", }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #F1F2F3", paddingBottom: "18px", marginBottom: "18px", }}>
                <AddNameBtn initialName={gridItem.title} placeholder="Your Name" onNameChange={(newName) => console.log("Updated Grid Title:", newName)} markerImage={marker} />
                <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#282829" }}>Page {gridItem.id}</Typography>
              </Box>

              {gridItem.notes.map((note) => (
                <Box key={note.id} sx={{ display: "flex", gap: "16px", marginBottom: "22px" }}>
                  <Fileupload fileuploadclass="instruction-upload" iconSrc="iconSrc" onFileSelect={(file) => console.log("Selected file:", file)} previewSize={{ width: 24, height: 24 }} onRemoveFile={() => console.log("File removed!")} />
                  <TextareaAutosize
                    minRows={4}
                    placeholder={`${gridItem.placeholderPrefix || "Write"} a note`}
                    value={note.value}
                    onChange={(e) => handleNoteChange(gridItem.id, note.id, e.target.value)}
                    style={{ width: "100%", padding: "16px", fontSize: "16px", fontWeight: "500", borderRadius: "10px", backgroundColor: "#F9FBFC", resize: "vertical", border: "0", }}
                  />
                  <Button onClick={() => removeNote(gridItem.id, note.id)} sx={{ border: "1px solid #F1F2F3", padding: "16px", borderRadius: "10px", minWidth: "56px", height: "56px", "&:hover": { backgroundColor: "transparent !important" }, ".MuiTouchRipple-root": { display: "none" }, }}>
                    <img style={{ cursor: "pointer" }} src={trashIcon} alt="trash" height={24} width={24} />
                  </Button>
                </Box>
              ))}
              <Button onClick={() => addNote(gridItem.id)} sx={{ padding: "0", textTransform: "capitalize", fontSize: "14px", fontWeight: "500", color: "#C8172F", display: "flex", justifyContent: "start" }}>
                <img style={{ marginRight: "8px" }} src={plusIcon} alt="plus" />{" "}
                Add Note
              </Button>
            </Box>
          </Grid>
          <Grid item sx={{ paddingLeft: "34px !important" }} md={1}>
            <Box sx={{ backgroundColor: "#FFF", borderRadius: "10px", padding: "12px", display: "flex", gap: "26px", flexWrap: "wrap", justifyContent: "center", }}>
              {/* <span style={{cursor: "grabbing",color: "#282829",fontSize: "19px",}}>⋮⋮</span> */}
              <Button onClick={() => handleCopyNote(gridItem.notes[gridItem.notes.length - 1]?.value || "")} sx={{ padding: "0", minWidth: "unset !important" }}><img src={copy} alt="copy" /></Button>
              <Button onClick={() => removeGrid(gridItem.id)} sx={{ padding: "0", minWidth: "unset !important" }}><img width={20} height={20} src={trash} alt="trash" /></Button>
            </Box>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default Notes;
